import { RootStore } from '../data/store'

export const isFromMock = false

export const AppConfig = {
  appVersion: '1.0.0',
  appName: 'PG',
}

const CardScheme = {
  VISA: 104,
  MASTER_CARD: 105,
  RUPAY: 199,
  DINERS: 107,
  AMEX: 103,
  CUP: 133,
  DISCOVER: 108,
  EuroPay: 106,
  JCB: 109,
  SODEXO: 4000, //bankId of sodexo
}

export const getCardVendorFromScheme = (scheme: string) => {
  switch (scheme) {
    case 'bgBank bg-visa_card':
      return 'visa'
    case 'bgBank bg-master_card':
      return 'mastercard'
    case 'bgBank bg-maestro_card':
      return 'maestro'
    case 'bgBank bg-rupay_card':
      return 'rupay'
    case 'bgBank bg-diner_card':
      return 'diners'
    case 'bgBank bg-ae_card':
    case 'bgBank bg-american':
      return 'amex'
    case 'bgBank bg-jcb_card':
      return 'jcb'
    case 'bgBank_bg_discover_card':
      return 'discover'
    case 'bgBank_bg_epay_card':
      return 'europay'
    case 'bgBank_bg_cup_card':
      return 'cup'
    default:
      return 'none'
  }
}

export const getCardVendor = (scheme: number) => {
  switch (scheme) {
    case CardScheme.VISA:
      return 'visa'
    case CardScheme.MASTER_CARD:
      return 'mastercard'
    case CardScheme.RUPAY:
      return 'rupay'
    case CardScheme.DINERS:
      return 'diners'
    case CardScheme.AMEX:
      return 'amex'
    case CardScheme.DISCOVER:
      return 'discover'
    case CardScheme.JCB:
      return 'jcb'
    case CardScheme.EuroPay:
      return 'europay'
    case CardScheme.CUP:
      return 'cup'
    case CardScheme.SODEXO:
      return 'sodexo'
    default:
      return 'none'
  }
}

const getCardLogo = (cardId: number) => {
  switch (cardId) {
    case CardScheme.VISA:
      return 'ic_cards_v.png'
    case CardScheme.MASTER_CARD:
      return 'ic_cards_mc.png'
    case CardScheme.RUPAY:
      return 'ic_cards_rp.png'
    case CardScheme.DINERS:
      return 'ic_cards_diner.png'
    case CardScheme.AMEX:
      return 'ic_cards_ae.png'
    case CardScheme.JCB:
      return 'ic_cards_jcb.png'
    case CardScheme.DISCOVER:
      return 'ic_cards_discover.png'
    case CardScheme.EuroPay:
      return 'ic_cards_epay.png'
    case CardScheme.CUP:
      return 'ic_cards_cup.png'
    case CardScheme.SODEXO:
      return 'sodexo.png'
    default:
      return 'ic_cards_default.png'
  }
}
const { REACT_APP_BASE_URL } = process.env
const PG_CONFIG = {
  BASE_URL: `${REACT_APP_BASE_URL}jfs/v1`,
  BASE_URL_V2: `${REACT_APP_BASE_URL}jfs/v2`,
  MERCHANT_URL: `${REACT_APP_BASE_URL}jfs/v2`,
  PAYMENT_BASE_URL: `${REACT_APP_BASE_URL}payments/jfs/v1`,
  PAYMENT_STATUS_BASE_URL: `${REACT_APP_BASE_URL}payments/jfs/v2`,
  BIN_BASE_URL: `${REACT_APP_BASE_URL}bin/v4`,
  UPI_MANDATE_BASE_URL: 'http://10.144.108.125:9002/jpb/v1/upi/mandate',
  MERCHANT_BASE_URL: 'http://10.144.108.106:7007/jfs/v1',
  VAULT_URL: `${REACT_APP_BASE_URL}vault/jfs/v2`,
  API_KEY: 'MyJioApiKey',
  EMS_BASE_URL: `${REACT_APP_BASE_URL}jfs/ems`,
  BASE_URL_NO_VERSION: `${REACT_APP_BASE_URL}`,
}
const UUID = 'b3463735-64c6-4137-a33e-8b009b33c0ba' // UUID = 'b3463735-64c6-4137-a33e-8b009b33c0ba' // UUID

const tokens = {
  appAccessToken: '',
  appIdToken: '',
}
const getRandomNumString = (length: number): string => {
  let result = ''
  const characters = '0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

const updateToken = (accToken: string, appIdToken: string) => {
  tokens.appAccessToken = accToken
  tokens.appIdToken = appIdToken
}

const getRandomAlphaNumString = (length: number): string => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  const charactersLength = characters.length
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

const getPaymentHeader = () => {
  return {
    // 'x-channel-id': '178485040430', //2103
    'x-trace-id': getRandomAlphaNumString(8),
    'X-API-Key': PG_CONFIG.API_KEY,
    'x-app-access-token': tokens.appAccessToken,
    'x-appid-token': tokens.appIdToken,
    ...(RootStore.config.isIntegration === 'true' ? { 'x-forward-server': 'integration' } : {}),
  }
}

const getSodexoCardPaymentHeader = (userIdToken: string, userAccessToken: string) => {
  return {
    'x-trace-id': getRandomAlphaNumString(15),
    'X-API-Key': PG_CONFIG.API_KEY,
    'x-app-access-token': tokens.appAccessToken,
    'x-appid-token': tokens.appIdToken,
    'x-userid-token': userIdToken,
    'x-user-access-token': userAccessToken,
  }
}

export const getJioFinHubHeader = () => {
  return {
    'x-trace-id': getRandomAlphaNumString(15),
    'X-API-Key': PG_CONFIG.API_KEY,
    'x-app-access-token': tokens.appAccessToken,
    'x-appid-token': tokens.appIdToken,
    'x-userid-token': RootStore.jioPayFinanceHub.customerSession.userIdentifierToken,
    'x-user-access-token': RootStore.jioPayFinanceHub.customerSession.userAccessToken,
    'x-channel-id': '2103',
  }
}

const getMMSHeader = () => {
  return {
    ...getPaymentHeader(),
    'X-API-Key': PG_CONFIG.API_KEY,
  }
}

const getMandateHeader = () => {
  return {
    'X-ACCESS-ID': getRandomAlphaNumString(8),
    'X-CHANNEL-ID': '',
    'X-AUTH-TOKEN': '',
    'X-API-Key': PG_CONFIG.API_KEY,
    'x-trace-id': getRandomAlphaNumString(8),
  }
}

const getHeader = () => {
  return {
    'Content-Type': 'application/json',
    'X-API-Key': PG_CONFIG.API_KEY,
    'X-UUID': UUID,
    'X-SOURCE': 'test',
    sessionId: '02449ed5-d878-40f5-aa05-33aa5ce8e61d',
    'X-CHANNEL-ID': '6162', //'3133',
    'x-trace-id': '01c570cf-2bdf-49d0-a126-baec7038bbd1',
    'x-device-info': 'device_token',
    'x-access-token': 'hello2',
    'x-jwt-token': 'session_token',
  }
}

// const getHeader = () => {
//   return {
//     'Content-Type': 'application/json',
//     'X-API-Key': PG_CONFIG.API_KEY,
//     'X-UUID': UUID,
//     'X-SOURCE': 'test',
//     sessionId: '02449ed5-d878-40f5-aa05-33aa5ce8e61d',
//     'X-CHANNEL-ID': '3133', //'3133',
//     'x-app-access-token': '2f7d7208-018c-4cbe-bc5e-6e8236338170APPACCESS',
//     'x-appid-token':
//       'wJdsd+2uKRDJRt8V+w0P6Y9n966FngiO0dLJ17ynuORnpubrPGuJk92y2RQkTlf7Py/wLkrMmBdd/yBtQf10gw1Yt5Ox04jzIJ2/GXMvMSL9k8K8K06/aewnO6zffH/NRnTRbhGoF79AE1zp7MUM12OLqBVTt6SU3ubfnkQJ6uTUCSDsIS3PTEYueS/uj2d/DuOHzUQUsU76ZciYTR55fAyKNp9RSMBK9NspMjB57ysogmDGJ7YhQs05rYtHMoqrUP46qY7Acc1l8IvpdSM6tfLmQ/QcoirHqWUOVJOHGNLWJ7H+cgqGWmeIIfIjr5F9EORF3RYW+NtRgMpS2aIJnu2jNAFOq6Wm67WmbAmKrnwi2osuC68k/I6dv64MKIBeUYtLLxa+lHdYicWxh88P15zycu/qW0BV/C9r3MTG0+H8RnlaYJ7LP4EZK6FeQ241sNAsDQbkGpJFDB/9VPzgBG7dmUIq9wOZ1tg2TtxPiPspZO/Ef+J8wYsE9U5LWKgjIuLz22B3+p/TY32KNVyB8r3kxjY+s+X5td3iVH7G3vnSZGNcScD5FwQ2yj2Mb7wBgUGNmyLLqFPUBvJizIExLkTR8ybarRihJP5bgfD/MVioM56xrsTcBC9O1kUL6lexuzlwJh1zvU26C8rdEq24pWfmDSS5JzMVYGTH6Zh307wUaOoOYFUKrZ25Zd+GHPiycK1wh0rJ9evEB/mavSsqWDwcJlBuQYOs+n2PDjzpXnRivcfH993OjNgf2XfbRYB4qHc9Uon4uGeZut0gcfW65A==',
//     'x-trace-id': '01c570cf-2bdf-49d0-a126-baec7038bbd1',
//     'x-device-info': 'device_token',
//     'x-access-token': 'hello2',
//     'x-jwt-token': 'session_token',
//   }
// }

const getURL: any = {
  fetchBanks: {
    baseUrl: PG_CONFIG.PAYMENT_BASE_URL,
    path: '/instruments/banks',
  },
  paymentsConfirm: {
    baseUrl: PG_CONFIG.PAYMENT_BASE_URL,
    path: '/payments/confirm',
  },
  mandate: {
    baseUrl: PG_CONFIG.PAYMENT_BASE_URL,
    path: '/mandate',
  },
  paymentsIntent: {
    baseUrl: PG_CONFIG.PAYMENT_BASE_URL,
    path: '/payments/intent',
  },
  paymentsStatus: {
    baseUrl: PG_CONFIG.PAYMENT_STATUS_BASE_URL,
    path: '/payments/status',
  },
  userAuthenticate: {
    baseUrl: PG_CONFIG.BASE_URL,
    path: '/user/authenticate',
  },
  authenticate: {
    baseUrl: PG_CONFIG.BASE_URL,
    path: '/app/authenticate',
  },
  convenienceFee: { baseUrl: PG_CONFIG.BASE_URL, path: '/ext/merchant/convenienceFee' },
  savedCards: { baseUrl: PG_CONFIG.VAULT_URL, path: '/instruments/fetch' },
  savedCardDetail: { baseUrl: PG_CONFIG.BASE_URL, path: '/instruments/0/' },
  balance: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/balance' },
  addDeleteCard: { baseUrl: PG_CONFIG.VAULT_URL, path: '/instruments' },
  instruments: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/instruments' },
  validatecard: { baseUrl: PG_CONFIG.BASE_URL, path: '/validatecard' },
  searchMerchant: { baseUrl: PG_CONFIG.BASE_URL, path: '/ext/merchant/searchMerchant' },
  searchEntity: { baseUrl: PG_CONFIG.BASE_URL_NO_VERSION, path: 'jfs/app/ems/v2/entity/searchentity' },
  emiRetrieve: { baseUrl: PG_CONFIG.BASE_URL_V2, path: '/ext/emi/merchant/retrieve' },
  emiBinValidate: { baseUrl: PG_CONFIG.BASE_URL, path: '/emi/bin/validate' },
  getMerchantConfigList: { baseUrl: PG_CONFIG.BASE_URL, path: '/ext/merchant/getMerchantConfigList' },
  getMerchantConfig: { baseUrl: PG_CONFIG.MERCHANT_URL, path: '/ext/merchant/getMerchantConfig' },
  getConfigList: { baseUrl: PG_CONFIG.BASE_URL, path: '/merchant/getMerchantConfig' },
  getUserInterface: { baseUrl: PG_CONFIG.BASE_URL, path: '/ext/merchant/getUserInterface' },
  getCards: { baseUrl: PG_CONFIG.BASE_URL, path: '/ext/merchant/getCards' },
  cancelIntent: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/payments/intent/' },
  validateVpa: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/payments/upi/vpa/validate' },
  binService: { baseUrl: PG_CONFIG.BIN_BASE_URL, path: '/details/card' },
  upiMandeteCrete: { baseUrl: PG_CONFIG.UPI_MANDATE_BASE_URL, path: '/process' },
  upiMandeteRevoke: { baseUrl: PG_CONFIG.UPI_MANDATE_BASE_URL, path: '/revoke' },
  upiMandeteUpdate: { baseUrl: PG_CONFIG.UPI_MANDATE_BASE_URL, path: '/update' },
  upiMandeteStatus: { baseUrl: PG_CONFIG.UPI_MANDATE_BASE_URL, path: '/transaction' },
  preProcess: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/payments/preProcess' },
  getOffers: { baseUrl: PG_CONFIG.BASE_URL, path: '/offer/fetch' },
  offerValidate: { baseUrl: PG_CONFIG.BASE_URL, path: '/offer/validate' },
  offerTxnApply: { baseUrl: PG_CONFIG.BASE_URL, path: '/offer/transaction/apply' },
  offerTxnUpdate: { baseUrl: PG_CONFIG.BASE_URL, path: '/offer/transaction/update' },
  offerTxnValidate: { baseUrl: PG_CONFIG.BASE_URL, path: '/offer/transaction/validate' },
  offerProductValidate: { baseUrl: PG_CONFIG.BASE_URL, path: '/billing/product/validate' },
  upiIntent: { baseUrl: PG_CONFIG.BASE_URL, path: '/payments/qr' },
  resolveApi: { baseUrl: PG_CONFIG.VAULT_URL, path: '/instruments/resolve/' },
  intentStatus: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/payments/intentStatus' },
  eligibilityApi: { baseUrl: PG_CONFIG.BASE_URL_V2, path: '/jioPayFinance/eligibility' },
  generateQr: { baseUrl: PG_CONFIG.PAYMENT_BASE_URL, path: '/merchant/qr' },
}
const getAPIURL = (apiName: string) => {
  return `${getURL[apiName].baseUrl}${getURL[apiName].path}`
}

export {
  getAPIURL,
  getCardLogo,
  getHeader,
  getMandateHeader,
  getMMSHeader,
  getPaymentHeader,
  getRandomAlphaNumString,
  getRandomNumString,
  getSodexoCardPaymentHeader,
  PG_CONFIG,
  updateToken,
  UUID,
}
